// Retired merge fields (TGCLOUD-1766 retired "Private" and "Private (Process)").
// The SAME file the server validator reads, inlined by Vite at build time; its
// header explains the rule. A retired token is recognised and renders blank
// (resolveToken), but is never offered: it is added here, to the render index,
// and never to the catalogue groups the picker lists.
import retiredFile from '../../../../../backend/data/retired-merge-fields.json';

function retiredDescriptor(entry, group) {
  return {
    token: entry.token,
    path: entry.path,
    label: entry.token,
    group,
    aliases: (entry.aliases || []).map((a) => String(a).toLowerCase().trim()),
    kind: 'scalar',
    source: 'retired',
    retired: true
  };
}

// Fills gaps only: a live field always keeps its token and its aliases.
function addRetired(map, entries, group) {
  for (const entry of entries || []) {
    const d = retiredDescriptor(entry, group);
    for (const k of [d.token.toLowerCase(), ...d.aliases]) {
      if (!map.has(k)) map.set(k, d);
    }
  }
}

function indexLeaves(leaves) {
  const map = new Map();
  for (const d of leaves) {
    const key = d.token.toLowerCase();
    if (!map.has(key)) map.set(key, d);
  }
  for (const d of leaves) {
    (d.aliases || []).forEach((a) => {
      const k = String(a).toLowerCase();
      if (!map.has(k)) map.set(k, d);
    });
  }
  return map;
}

/**
 * @param {Array<{group:string, fields:object[]}>} groups
 * @returns {{ topLevel: Map, collections: Map }}
 */
export function buildIndex(groups) {
  const collections = new Map();
  const leaves = [];
  for (const g of groups || []) {
    for (const d of g.fields || []) {
      if (d.kind === 'collection') {
        const itemsByToken = indexLeaves(d.itemFields || []);
        addRetired(
          itemsByToken,
          (retiredFile.collectionItems || {})[d.token],
          d.token
        );
        collections.set(d.token.toLowerCase(), { ...d, itemsByToken });
      } else {
        leaves.push(d);
      }
    }
  }
  const topLevel = indexLeaves(leaves);
  addRetired(topLevel, retiredFile.topLevel, 'Retired');
  return { topLevel, collections };
}
